var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardForm',{attrs:{"titulo":_vm.titleCard}},[_c('DataList',{ref:"datatable",staticClass:"mb-3",attrs:{"url":"admins","fields":_vm.fields,"toCuil":_vm.toCuil,"rowClick":_vm.opciones}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }